import React from "react";
import {} from "react-router";
import { Route, Switch } from "react-router-dom";
import AccountLayout from "./components/AccountLayout";
import OnboardingWizard from "./components/Onboarding";

class Entry extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    const {
      match: { path }
    } = this.props;
    return (
      <div>
        <Switch>
          <Route path={`${path}/onboarding`} component={OnboardingWizard} />
          <Route component={AccountLayout} />
        </Switch>
      </div>
    );
  }
}

export default Entry;



// WEBPACK FOOTER //
// ./src/App/account/index.js